
// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-free/css/all.css";
import 'lightgallery/src/sass/lightgallery.scss';

import {
    jarallax,
    jarallaxVideo
} from 'jarallax';
import 'bootstrap';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import AOS from 'aos';

import Instafeed from 'instafeed.js';

window.Instafeed = Instafeed;

$(function () {

    basicNavigation();

    jarallaxVideo();

    jarallax(document.querySelectorAll('.HomePage .parallax.intro'), {
        videoSrc: 'https://www.youtube.com/watch?v=QGAMTlI6XxY',
        videoStartTime: 35,
        videoEndTime: 120,
        speed: 0.5
    });

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');

    AOS.init({
        once: true,
        disable: function() {
            var maxWidth = 768;
            return window.innerWidth < maxWidth;
        }
    });

    /*
    $('.carousel.full-height .slick').slick({
        autoplay: true,
        autoplaySpeed: 10000,
        fade: true,
        arrows: false
    });
     */

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    var swiper = new Swiper(".carousel", {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    });

    var sponsorsSwiper = new Swiper(".sponsors-wrapper", {
        loop: true,
        autoplay: {
            delay: 5000
        }
    });

    var gallerySwiper = new Swiper(".gallery-swiper", {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
            delay: 1000
        }
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev",
        // },
    });

    $('.swiper-button-next').on('click', function() {
        gallerySwiper.slideNext();
    });

    $('.swiper-button-prev').on('click', function() {
        gallerySwiper.slidePrev();
    });

    if($('.team-members').length > 0) {
        var id = '';
        console.log('hi');
        $('.team-member').on('click', function() {
            id = $(this).attr('id');
            console.log('hi 2');
            setupModal(id);
        });
    }

});

function setupModal(id) {
    var content = $('.team-member-'+id).data('description');
    var image = $('.team-member-'+id).data('image');
    var name = $('.team-member-'+id).data('name');
    var position = $('.team-member-'+id).data('position');

    $('.modal-body .content-wrapper .description').html(content);
    $('.modal-body .content-wrapper .name').html(name);
    $('.modal-body .content-wrapper .position').html(position);
    $('.modal-body .modal-image-wrapper .modal-image').attr('src', image);
    $('.modal-title').html(name);
}
